/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */

export type BatchProcessItemStatus = typeof BatchProcessItemStatus[keyof typeof BatchProcessItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BatchProcessItemStatus = {
  Pending: 'Pending',
  InProcess: 'InProcess',
  Deferred: 'Deferred',
  Succeeded: 'Succeeded',
  NoAction: 'NoAction',
  Failed: 'Failed',
} as const;
